const form_submit_button_error =
  'You have items in your cart. Please pay and save if you want to save your changes'

export default form_submit_button_error
